fragment PeepRelatedLeadStatFragment on LeadStat {
    count
    status
    value {
        formattedValue {
            prefix
            suffix
            formatted
        }
    }
}
